// extracted by mini-css-extract-plugin
module.exports = {"text-input-form":"text-input-form_text-input-form__uUUMf","clear-button":"text-input-form_clear-button__bh2rt"};